export default __webpack_public_path__ + "static/media/vehicle_card_default.37db157d.png";